import { Recaptcha as ReCAPTCHA, Checkbox } from '@patrianna/core-components'
import cx from 'classnames'
import { useState } from 'react'

import useFakeCaptcha from 'components/Recaptcha/useFakeCaptcha'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getImageBasedCaptchaSelector } from 'src/store/modules/appConfig/selectors'
import { openSnackbar } from 'store/modules/snackbar/actions'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

type Props = {
  verifyCallback: (token: string) => void
  reset?: boolean
  className?: string
  withFakeCaptcha?: boolean
  source?: string
}

export default function Recaptcha({ verifyCallback, reset, className, withFakeCaptcha, source }: Props) {
  const [verified, setVerified] = useState(false)
  const useImageBasedCaptcha = useAppSelector(getImageBasedCaptchaSelector)
  const shouldShowImageBasedCaptcha = useImageBasedCaptcha && source === 'sweepstakes'

  const { isDarkMode } = useThemeContext()
  const isFakeCaptcha = useFakeCaptcha()

  const RECAPTCHA_KEY_ID = shouldShowImageBasedCaptcha
    ? process.env.RECAPTCHA_IMAGE_BASED_KEY_ID
    : process.env.RECAPTCHA_KEY_ID
  const RECAPTCHA_BYPASS = shouldShowImageBasedCaptcha
    ? process.env.RECAPTCHA_IMAGE_BASED_BYPASS
    : process.env.RECAPTCHA_BYPASS

  const fakeVerifyCallBack = () => {
    setVerified(true)
    verifyCallback(RECAPTCHA_BYPASS)
  }

  return (
    <>
      {isFakeCaptcha && withFakeCaptcha ? (
        <div className={cx(classes.fakeRecaptcha)} onClick={fakeVerifyCallBack}>
          <Checkbox checked={verified} value={verified} dataTestId='checkbox-recaptcha' />
          {"I'm not a robot (fake)"}
        </div>
      ) : (
        <ReCAPTCHA
          sitekey={RECAPTCHA_KEY_ID}
          verifyCallback={verifyCallback}
          className={cx(classes.recaptcha, className)}
          theme={isDarkMode ? 'dark' : 'light'}
          reset={reset}
        />
      )}
    </>
  )
}
